"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRequestVideoCallbackTime = void 0;
const react_1 = require("react");
const useRequestVideoCallbackTime = (mediaRef, mediaType) => {
    const currentTime = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        const { current } = mediaRef;
        if (current) {
            currentTime.current = current.currentTime;
        }
        else {
            currentTime.current = null;
            return;
        }
        if (mediaType !== 'video') {
            currentTime.current = null;
            return;
        }
        const videoTag = current;
        if (!videoTag.requestVideoFrameCallback) {
            return;
        }
        let cancel = () => undefined;
        const request = () => {
            if (!videoTag) {
                return;
            }
            const cb = videoTag.requestVideoFrameCallback((_, info) => {
                currentTime.current = info.mediaTime;
                request();
            });
            cancel = () => {
                videoTag.cancelVideoFrameCallback(cb);
                cancel = () => undefined;
            };
        };
        request();
        return () => {
            cancel();
        };
    }, [mediaRef, mediaType]);
    return currentTime;
};
exports.useRequestVideoCallbackTime = useRequestVideoCallbackTime;
